import { F as o } from "../../../vendor-Dd6qj6gJ.js";
const e = "global", t = o();
export {
  e as GLOBAL_SCOPE,
  t as IS_MAC
};
